import { defineStore } from 'pinia'

export const useToastStore = defineStore('toast', {
  state: () => ({
    toasts: [],
  }),

  actions: {
    addToast(toast) {
      const id = Date.now() + Math.random()
      const newToast = {
        id,
        message: toast.message,
        type: toast.type || 'info',
        duration: toast.duration || 5000,
        persistent: toast.persistent || false,
      }

      this.toasts.push(newToast)

      if (!newToast.persistent) {
        setTimeout(() => {
          this.removeToast(id)
        }, newToast.duration)
      }

      return id
    },

    removeToast(id) {
      const index = this.toasts.findIndex((toast) => toast.id === id)
      if (index > -1) {
        this.toasts.splice(index, 1)
      }
    },

    clearAllToasts() {
      this.toasts = []
    },

    success(message, options = {}) {
      return this.addToast({ message, type: 'success', ...options })
    },

    error(message, options = {}) {
      return this.addToast({ message, type: 'error', persistent: true, ...options })
    },

    warning(message, options = {}) {
      return this.addToast({ message, type: 'warning', ...options })
    },

    info(message, options = {}) {
      return this.addToast({ message, type: 'info', ...options })
    },
  },
})
